document.addEventListener('DOMContentLoaded', function () {
  const IS_DESKTOP = window.innerWidth >= 990;
  const SCROLL_DURATION_MS = 750;

  const configuratorGuideToggle = document.querySelector('.configurator-guide');
  const configuratorGuideModal = document.querySelector('.configurator-modal');
  const packageCards = document.querySelectorAll('.configurator-card-package:not(.disabled)');
  const productCards = document.querySelectorAll('.configurator-card-product');
  const packageSections = document.querySelectorAll('.configurator-package');
  const configuratorFooter = document.querySelector('.configurator-footer');
  const totalElements = document.querySelectorAll('.configurator-total');
  const mainProduct = document.querySelector('.configurator-card.disabled');
  const productForm = document.querySelector('.product-form-configurator');
  const mainVariantIdInput = productForm ? productForm.querySelector('input[name="id"].product-variant-id') : null;
  const stickyCta = document.querySelector('.configurator-sticky-bar-cta');
  const stickySubtotal = document.querySelector('.configurator-sticky-bar-subtotal');
  const stickyPrompt = document.querySelector('.configurator-sticky-bar-prompt');
  const expandButtons = document.querySelectorAll('.configurator-expand-accessories');
  const warrantyRow = document.querySelector('[data-configurator-warranty-row]');
  const warrantyCards = document.querySelectorAll('.configurator-warranty');
  const footerCta = document.querySelector('.configurator-footer-cta');
  const crossbowCards = document.querySelectorAll('[data-crossbow-card]');
  const soldoutNote = document.querySelector('[data-configurator-soldout-note]');
  const stepSelect = document.querySelector('[data-configurator-step="select"]');
  const stepBuild = document.querySelector('[data-configurator-step="build"]');
  const stepBackBtn = document.querySelector('[data-configurator-step-back]');

  let mainProductPrice = 0;
  let currentItemIndex = 1; // Начинаем с 1, так как 0 для основного товара

  // Функция плавного скролла с заданной длительностью
  function smoothScrollTo(targetPosition, duration) {
    if (!IS_DESKTOP) return;

    const startPosition = window.pageYOffset;
    const distance = targetPosition - startPosition;
    let startTime = null;

    function animation(currentTime) {
      if (startTime === null) startTime = currentTime;
      const timeElapsed = currentTime - startTime;
      const run = ease(timeElapsed, startPosition, distance, duration);
      window.scrollTo(0, run);
      if (timeElapsed < duration) requestAnimationFrame(animation);
    }

    // Функция плавности (ease-in-out)
    function ease(t, b, c, d) {
      t /= d / 2;
      if (t < 1) return c / 2 * t * t + b;
      t--;
      return -c / 2 * (t * (t - 2) - 1) + b;
    }

    requestAnimationFrame(animation);
  }

  // Единый отступ под липкой шапкой для ВСЕХ скроллов конфигуратора (открытие,
  // выбор пакета, «назад к пакетам», раскрытие аксессуаров) — чтобы поведение
  // было одинаковым. Значение взято от перехода «назад» (его пользователь счёл
  // эталонным): высота sticky-шапки + воздух.
  function configuratorHeaderOffset() {
    const bar = document.querySelector('.configurator-sticky-bar');
    const barH = bar ? bar.offsetHeight : 80;
    return barH + 56;
  }

  // Скролл при загрузке на десктопе
  if (IS_DESKTOP) {
    setTimeout(() => {
      // Проверяем URL параметр package
      const urlParams = new URLSearchParams(window.location.search);
      const packageSlug = urlParams.get('package');
      let targetPackageCard = null;

      if (packageSlug) {
        targetPackageCard = document.querySelector(`.configurator-card-package[data-slug="${packageSlug}"]`);
      }

      if (targetPackageCard) {
        // Если указан пакет в URL, кликаем по нему
        // Клик сам запустит скролл к контенту пакета (см. обработчик клика)
        targetPackageCard.click();
      } else {
        // Стандартное поведение - скролл к заголовку выбора пакета
        const selectPackageHeading = document.getElementById('configurator-select-package');
        if (selectPackageHeading) {
          const elementPosition = selectPackageHeading.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - configuratorHeaderOffset();

          smoothScrollTo(offsetPosition, SCROLL_DURATION_MS);
        }
      }
    }, 500);
  } else {
    // Для мобильных тоже проверяем параметр, но без начального скролла к заголовку
    setTimeout(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const packageSlug = urlParams.get('package');
        if (packageSlug) {
          const targetPackageCard = document.querySelector(`.configurator-card-package[data-slug="${packageSlug}"]`);
          if (targetPackageCard) {
            targetPackageCard.click();
          }
        }
    }, 500);
  }

  if (configuratorGuideModal) {
    const closeGuideModal = () => {
      configuratorGuideModal.classList.remove('active');
      document.body.style.overflow = "";
    };

    if (configuratorGuideToggle) {
      configuratorGuideToggle.addEventListener('click', () => {
        configuratorGuideModal.classList.add('active');
        document.body.style.overflow = "hidden";
      });
    }

    // Кнопка Close (берём именно из этой модалки, а не первую на странице).
    const close = configuratorGuideModal.querySelector('.configurator-modal-close');
    if (close) close.addEventListener('click', closeGuideModal);

    // Закрытие по клику на затемнённый фон. Раньше его не было: если пользователь
    // промахивался мимо кнопки Close, модалка «залипала» — тёмный полноэкранный
    // оверлей + заблокированный скролл (body overflow:hidden), что выглядело как
    // «чёрный экран / подвисание». Warranty-модалка уже умеет так закрываться.
    configuratorGuideModal.addEventListener('click', (e) => {
      if (e.target === configuratorGuideModal) closeGuideModal();
    });

    // И по Escape.
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && configuratorGuideModal.classList.contains('active')) closeGuideModal();
    });
  }

  // Ссылка в шапке ведёт на коллекцию арбалетов (шаг 0 — выбор арбалета).
  // Это обычная ссылка, без JS-перехвата: «назад» при желании делается
  // кнопкой браузера, дублировать её не нужно.

  // Получаем цену основного товара (из data-price, см. readPrice)
  if (mainProduct) {
    mainProductPrice = readPrice(mainProduct);
  }

  // Стартовое состояние sticky CTA (до выбора пакета)
  setStickyState(false, false);

  // Сбрасывает развернутые accessories (Custom внутри Hunting/Fishing)
  function collapseEmbeddedAccessories() {
    expandButtons.forEach(btn => {
      btn.setAttribute('aria-expanded', 'false');
      const label = btn.querySelector('.configurator-expand-accessories-label');
      if (label) {
        const openLabel = label.getAttribute('data-label-open');
        if (openLabel) label.textContent = openLabel;
      }
    });

    document.querySelectorAll('.configurator-package--embedded').forEach(el => {
      el.classList.remove('configurator-package--embedded');
    });

    document.querySelectorAll('.configurator-card-product.is-duplicate-hidden').forEach(el => {
      el.classList.remove('is-duplicate-hidden');
    });

    // Возвращаем категории, ранее скрытые из-за того что все их товары — дубли
    document.querySelectorAll('.configurator-package .configurator-subheading.hidden, .configurator-package .configurator-block.hidden').forEach(el => {
      el.classList.remove('hidden');
    });
  }

  // Если в развернутом Custom внутри активного пакета все товары
  // категории помечены .is-duplicate-hidden — прячем и подзаголовок,
  // и блок, чтобы не показывать пустой раздел.
  // Функция идемпотентна: повторный вызов корректно покажет категорию,
  // если после новых отметок в ней появились видимые товары.
  function hideEmptyCategoriesIn(targetPackage) {
    const blocks = targetPackage.querySelectorAll('.configurator-block');
    blocks.forEach(block => {
      const productCards = block.querySelectorAll('.configurator-card-product');
      if (productCards.length === 0) return;
      const shouldHide = !block.querySelector('.configurator-card-product:not(.is-duplicate-hidden)');
      block.classList.toggle('hidden', shouldHide);
      const prev = block.previousElementSibling;
      if (prev && prev.classList.contains('configurator-subheading')) {
        prev.classList.toggle('hidden', shouldHide);
      }
    });
  }

  // --- Пошаговый флоу (квиз): экран 1 «выбор пакета» ⇄ экран 2 «сборка пакета» ---
  // Если разметка двухшаговая (есть оба контейнера) — показываем по одному экрану.
  // Иначе (старая одностраничная разметка) функции no-op, поведение прежнее.
  const HAS_STEPS = !!(stepSelect && stepBuild);
  const PREFERS_REDUCED_MOTION = window.matchMedia
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let stepAnimating = false;

  // Куда скроллить при смене экрана:
  //  - на «build» — в самый верх (там кнопка «Back to packages» + содержимое);
  //  - на «select» (назад к пакетам) — к заголовку «Select & customize…»,
  //    чтобы не выбрасывать пользователя к hero наверху.
  function scrollForStep(toBuild, smooth) {
    // Якорь — верх соответствующего экрана: на «build» это кнопка
    // «Back to packages», на «select» — заголовок «Select & customize…».
    // Отступ единый (configuratorHeaderOffset), чтобы оба экрана и все
    // прочие скроллы вставали на одинаковую высоту под липкой шапкой.
    const inEl = toBuild ? stepBuild : stepSelect;
    const anchor = toBuild
      ? document.querySelector('.configurator-back-to-packages')
      : document.getElementById('configurator-select-package');
    let top = 0;
    if (anchor) {
      // Во время кроссфейда входящий экран сдвинут transform'ом (translateY),
      // поэтому замер дал бы промежуточную позицию и скролл промахнулся бы на
      // величину сдвига. Снимаем transform на момент замера (синхронно, в том же
      // тике — на экране это не отрисуется), чтобы взять ФИНАЛЬНУЮ позицию якоря.
      const savedTransform = inEl ? inEl.style.transform : '';
      if (inEl) inEl.style.transform = 'none';
      top = Math.max(0, anchor.getBoundingClientRect().top + window.pageYOffset - configuratorHeaderOffset());
      if (inEl) inEl.style.transform = savedTransform;
    }
    window.scrollTo({ top: top, behavior: smooth ? 'smooth' : 'auto' });
  }

  // Мгновенное переключение (без анимации) — fallback / reduced-motion.
  function setStepInstant(toBuild) {
    stepSelect.classList.toggle('hidden', toBuild);
    stepBuild.classList.toggle('hidden', !toBuild);
    scrollForStep(toBuild, false);
  }

  // Плавный переход между экранами — ОДНОВРЕМЕННЫЙ кроссфейд («перетекание»,
  // не «моргание»): входящий экран встаёт в поток и сразу задаёт высоту, а
  // уходящий на время перехода приподнимается в absolute (накладывается сверху)
  // и плавно гаснет/уезжает. Оба анимируются одновременно — пустого кадра нет.
  function goToStep(step) {
    if (!HAS_STEPS) return;
    const toBuild = step === 'build';
    const outEl = toBuild ? stepSelect : stepBuild;
    const inEl = toBuild ? stepBuild : stepSelect;

    // Уже на нужном экране — ничего не делаем.
    if (outEl.classList.contains('hidden')) return;

    if (PREFERS_REDUCED_MOTION) {
      setStepInstant(toBuild);
      return;
    }
    if (stepAnimating) return;
    stepAnimating = true;

    const parent = outEl.parentElement; // .configurator-body
    const prevParentPos = parent.style.position;
    parent.style.position = 'relative';

    // Входящий — в нормальном потоке, задаёт высоту контейнера, стартует прозрачным.
    inEl.classList.remove('hidden');
    inEl.style.opacity = '0';
    inEl.style.transform = 'translateY(12px)';

    // Уходящий — поверх (absolute), накладывается там же, где был.
    outEl.style.position = 'absolute';
    outEl.style.top = '0';
    outEl.style.left = '0';
    outEl.style.right = '0';
    outEl.style.opacity = '1';
    outEl.style.transform = 'translateY(0)';
    outEl.style.pointerEvents = 'none';

    // reflow, чтобы стартовые значения применились
    // eslint-disable-next-line no-unused-expressions
    inEl.offsetHeight;

    // Скроллим к нужному месту входящего экрана параллельно с анимацией.
    scrollForStep(toBuild, true);

    inEl.style.transition = 'opacity 0.4s ease, transform 0.45s cubic-bezier(0.4,0,0.2,1)';
    inEl.style.opacity = '1';
    inEl.style.transform = 'translateY(0)';

    outEl.style.transition = 'opacity 0.3s ease, transform 0.45s cubic-bezier(0.4,0,0.2,1)';
    outEl.style.opacity = '0';
    outEl.style.transform = 'translateY(-16px)';

    let done = false;
    const finish = () => {
      if (done) return;
      done = true;
      inEl.removeEventListener('transitionend', onIn);
      outEl.classList.add('hidden');
      // Сбрасываем все inline-стили перехода.
      ['position', 'top', 'left', 'right', 'opacity', 'transform', 'transition', 'pointerEvents'].forEach(p => {
        outEl.style[p] = '';
      });
      inEl.style.transition = '';
      inEl.style.opacity = '';
      inEl.style.transform = '';
      parent.style.position = prevParentPos;
      stepAnimating = false;
    };
    const onIn = (ev) => {
      if (ev && ev.propertyName !== 'opacity') return;
      finish();
    };
    inEl.addEventListener('transitionend', onIn);
    // Страховка, если transitionend не сработает.
    setTimeout(finish, 700);
  }

  // Обработка кликов на пакеты
  packageCards.forEach((card, index) => {
    card.addEventListener('click', function () {
      const cardId = this.id;

      if (!cardId) return;

      // Сворачиваем любые развернутые accessories перед переключением
      collapseEmbeddedAccessories();

      // Убираем активность со всех пакетов
      packageCards.forEach(c => c.classList.remove('active'));
      packageSections.forEach(p => p.classList.add('hidden'));

      // Убираем активность со всех товаров и сбрасываем их состояние
      productCards.forEach(product => {
        product.classList.remove('active');
      });

      // Активируем выбранный пакет
      this.classList.add('active');

      // Находим и показываем соответствующий пакет
      const targetPackage = document.querySelector(`.configurator-package[data-id="${cardId}"]`);
      if (targetPackage) {
        targetPackage.classList.remove('hidden');

        // Автоматически выбираем все продукты для средних пакетов
        // (не первый и не последний)
        const totalPackages = packageCards.length;
        if (index > 0 && index < totalPackages - 1) {
          const productsInPackage = targetPackage.querySelectorAll('.configurator-card-product');
          productsInPackage.forEach(product => {
            product.classList.add('active');
          });
        }
      }

      // Показываем футер
      if (configuratorFooter) configuratorFooter.classList.remove('hidden');
      if (warrantyRow) warrantyRow.classList.remove('hidden');

      // Переходим на экран 2 (сборка пакета). На старой одностраничной
      // разметке (HAS_STEPS=false) — просто плавный скролл к контенту, как раньше.
      if (HAS_STEPS) {
        goToStep('build');
      } else if (IS_DESKTOP && !this.classList.contains('base-package')) {
        setTimeout(() => {
          const activePackage = document.querySelector('.configurator-package:not(.hidden)');
          if (!activePackage) return;

          const targetElement = activePackage.querySelector('.configurator-subheading');
          if (!targetElement) return;

          const elementPosition = targetElement.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - configuratorHeaderOffset();

          smoothScrollTo(offsetPosition, SCROLL_DURATION_MS);
        }, 200);
      }

      // Арбалет снова включён при каждом (пере)выборе пакета.
      if (mainVariantIdInput) mainVariantIdInput.disabled = false;
      crossbowCards.forEach(c => c.classList.add('active'));
      syncWarrantyAvailability();

      // Сбрасываем total до цены основного товара
      resetTotalToMainProduct();

      // Очищаем форму от дополнительных input'ов
      clearFormInputs();

      // Обновляем total и форму с учетом автоматически выбранных товаров
      updateTotal();
      updateFormInputs();
    });
  });

  // Полный сброс выбора к стартовому состоянию конфигуратора (как при
  // первой загрузке): пакет не выбран, sticky-сумма / CTA / футер скрыты,
  // аксессуары и гарантия сняты, арбалет снова включён. Секции пакетов тут
  // НЕ прячем — это делает обработчик выбора пакета, а так уходящий экран
  // успевает плавно «угаснуть» вместе со своим содержимым.
  function resetSelection() {
    collapseEmbeddedAccessories();

    // Снимаем выбор пакета и всех товаров.
    packageCards.forEach(c => c.classList.remove('active'));
    productCards.forEach(p => p.classList.remove('active'));

    // Снимаем гарантию.
    warrantyCards.forEach(card => {
      card.classList.remove('active');
      const input = card.querySelector('.configurator-warranty-input');
      if (input) input.checked = false;
    });

    // Арбалет снова включён (на случай, если его убирали).
    if (mainVariantIdInput) mainVariantIdInput.disabled = false;
    crossbowCards.forEach(c => c.classList.add('active'));
    syncWarrantyAvailability();

    // Чистим форму и сбрасываем сумму к стартовому состоянию.
    clearFormInputs();
    resetTotalToMainProduct();
    updateTotal(); // нет активного пакета → прячет sticky-сумму, CTA и футер
  }

  // Кнопка «Back» на экране 2 (в футере) — возврат к выбору пакета
  // с полным сбросом выбора к стартовому состоянию.
  if (stepBackBtn) {
    stepBackBtn.addEventListener('click', () => {
      goToStep('select');
      resetSelection();
    });
  }

  // Обработка кликов на товары в пакетах
  productCards.forEach(card => {
    card.addEventListener('click', function (e) {
      // Проверяем, что клик не был по элементам деталей
      if (e.target.closest('.configurator-card-details-toggle') ||
        e.target.closest('.configurator-card-details')) {
        return; // Не активируем карточку
      }

      // Распроданный аксессуар (data-available="false") выбрать нельзя —
      // он не отгрузится так же, как распроданный арбалет. Бейдж "Sold out"
      // на карточке уже показан из Liquid.
      if (this.classList.contains('configurator-card--unavailable')) {
        return;
      }

      this.classList.toggle('active');
      updateTotal();
      updateFormInputs();
    });
  });

  // --- Removable crossbow line (внутри «Your package includes») ---
  // Арбалет можно убрать (для тех, у кого он уже есть) — тогда в корзину
  // уходят только аксессуары. Сам арбалет по-прежнему добавляется штатно
  // (как главный товар формы); при снятии мы отключаем его hidden-input,
  // поэтому он не уходит в /cart/add.
  function crossbowIncluded() {
    return mainVariantIdInput ? !mainVariantIdInput.disabled : true;
  }

  // Доступность арбалета берём из data-available на его карточке — это тот же
  // флаг Shopify variant.available, что и на обычной странице товара (кнопка
  // SOLD OUT). Если арбалет распродан в текущем регионе, покупка с ним
  // невозможна: кнопку блокируем, пока он включён в пакет. Снять арбалет →
  // можно заказать только аксессуары (для тех, у кого арбалет уже есть).
  function crossbowAvailable() {
    const card = crossbowCards[0];
    if (!card) return true;
    return card.getAttribute('data-available') !== 'false';
  }

  // Гарантия покупается только с арбалетом: при снятии — снять и заблокировать.
  function syncWarrantyAvailability() {
    const enabled = crossbowIncluded();
    warrantyCards.forEach(card => {
      card.classList.toggle('configurator-warranty--disabled', !enabled);
      const input = card.querySelector('.configurator-warranty-input');
      if (!enabled) {
        card.classList.remove('active');
        if (input) input.checked = false;
      }
      if (input) input.disabled = !enabled;
    });
  }

  function setCrossbowIncluded(included) {
    if (mainVariantIdInput) mainVariantIdInput.disabled = !included;
    crossbowCards.forEach(c => c.classList.toggle('active', included));
    syncWarrantyAvailability();
    updateTotal();
    updateFormInputs();
  }

  crossbowCards.forEach(card => {
    card.addEventListener('click', function (e) {
      if (e.target.closest('.configurator-card-details-toggle') ||
        e.target.closest('.configurator-card-details')) {
        return;
      }
      setCrossbowIncluded(!card.classList.contains('active'));
    });
  });

  // Warranty toggle — keeps all rendered warranty cards in sync (same variant in all packages).
  function setWarrantyActive(isActive) {
    warrantyCards.forEach(card => {
      card.classList.toggle('active', isActive);
      const input = card.querySelector('.configurator-warranty-input');
      if (input) input.checked = isActive;
    });
    updateTotal();
    updateFormInputs();
  }

  const warrantyModal = document.querySelector('.configurator-modal--warranty');

  function openWarrantyModal() {
    if (!warrantyModal) return;
    warrantyModal.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeWarrantyModal() {
    if (!warrantyModal) return;
    warrantyModal.classList.remove('active');
    document.body.style.overflow = '';
  }

  warrantyCards.forEach(card => {
    const input = card.querySelector('.configurator-warranty-input');
    if (!input) return;
    // Native label→input click toggles the checkbox; sync all cards on change.
    input.addEventListener('change', () => setWarrantyActive(input.checked));
    // The terms link sits inside the <label>; intercept so clicking it doesn't toggle.
    const termsLink = card.querySelector('.configurator-warranty-terms-link');
    if (termsLink) {
      termsLink.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        openWarrantyModal();
      });
    }
  });

  if (warrantyModal) {
    const closeBtn = warrantyModal.querySelector('[data-warranty-modal-close]');
    if (closeBtn) closeBtn.addEventListener('click', closeWarrantyModal);
    warrantyModal.addEventListener('click', (e) => {
      if (e.target === warrantyModal) closeWarrantyModal();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && warrantyModal.classList.contains('active')) closeWarrantyModal();
    });
  }

  // Анимированное раскрытие / сворачивание секции
  function animateExpand(el) {
    el.style.overflow = 'hidden';
    el.style.maxHeight = '0px';
    el.style.opacity = '0';
    // Force reflow
    // eslint-disable-next-line no-unused-expressions
    el.offsetHeight;
    const target = el.scrollHeight;
    el.style.transition = 'max-height 0.45s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease';
    el.style.maxHeight = target + 'px';
    el.style.opacity = '1';
    const cleanup = (e) => {
      if (e && e.propertyName !== 'max-height') return;
      el.style.transition = '';
      el.style.maxHeight = '';
      el.style.overflow = '';
      el.style.opacity = '';
      el.removeEventListener('transitionend', cleanup);
    };
    el.addEventListener('transitionend', cleanup);
  }

  function animateCollapse(el, onDone) {
    const current = el.scrollHeight;
    el.style.overflow = 'hidden';
    el.style.maxHeight = current + 'px';
    el.style.opacity = '1';
    // eslint-disable-next-line no-unused-expressions
    el.offsetHeight;
    el.style.transition = 'max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.25s ease';
    el.style.maxHeight = '0px';
    el.style.opacity = '0';
    const cleanup = (e) => {
      if (e && e.propertyName !== 'max-height') return;
      el.style.transition = '';
      el.style.maxHeight = '';
      el.style.overflow = '';
      el.style.opacity = '';
      el.removeEventListener('transitionend', cleanup);
      if (typeof onDone === 'function') onDone();
    };
    el.addEventListener('transitionend', cleanup);
  }

  // Обработка кликов на «Add accessories» внутри Hunting/Fishing/...
  expandButtons.forEach(button => {
    button.addEventListener('click', function (e) {
      e.stopPropagation();

      const targetId = button.getAttribute('data-expand-accessories');
      if (!targetId) return;
      const targetPackage = document.querySelector(`.configurator-package[data-id="${targetId}"]`);
      if (!targetPackage) return;

      const isExpanded = button.getAttribute('aria-expanded') === 'true';
      const label = button.querySelector('.configurator-expand-accessories-label');

      if (isExpanded) {
        // Свернуть с анимацией
        button.setAttribute('aria-expanded', 'false');
        if (label) {
          const openLabel = label.getAttribute('data-label-open');
          if (openLabel) label.textContent = openLabel;
        }
        animateCollapse(targetPackage, () => {
          targetPackage.classList.add('hidden');
          targetPackage.classList.remove('configurator-package--embedded');
          targetPackage.querySelectorAll('.configurator-card-product.is-duplicate-hidden').forEach(el => {
            el.classList.remove('is-duplicate-hidden');
          });
          // Возвращаем ранее скрытые категории, чтобы следующий экспанд начал с чистой раскладки
          targetPackage.querySelectorAll('.configurator-subheading.hidden, .configurator-block.hidden').forEach(el => {
            el.classList.remove('hidden');
          });
          updateTotal();
          updateFormInputs();
        });
        return;
      }

      // Развернуть: собираем data-id уже присутствующих в активном пакете товаров
      const parentPackage = button.closest('.configurator-package');
      const existingIds = new Set();
      if (parentPackage) {
        parentPackage.querySelectorAll('.configurator-card-product').forEach(card => {
          const id = card.getAttribute('data-id');
          if (id) existingIds.add(id);
        });
      }

      // Скрываем дубли в Custom
      targetPackage.querySelectorAll('.configurator-card-product').forEach(card => {
        const id = card.getAttribute('data-id');
        if (id && existingIds.has(id)) {
          card.classList.add('is-duplicate-hidden');
        }
      });

      // Прячем полностью пустые категории (все товары — дубли)
      hideEmptyCategoriesIn(targetPackage);

      targetPackage.classList.remove('hidden');
      targetPackage.classList.add('configurator-package--embedded');
      button.setAttribute('aria-expanded', 'true');
      if (label) {
        const closeLabel = label.getAttribute('data-label-close');
        if (closeLabel) label.textContent = closeLabel;
      }
      animateExpand(targetPackage);

      // Плавный скролл до заголовка раскрытого списка после анимации — с тем же
      // единым отступом, что и остальные скроллы (открытие / выбор пакета / назад).
      // Якорь — заголовок «All accessories»; запасной вариант — сам контейнер
      // (он всегда виден, в отличие от скрытого в embedded основного заголовка).
      if (IS_DESKTOP) {
        setTimeout(() => {
          const anchor = targetPackage.querySelector('.configurator-heading--accessories') || targetPackage;
          const elementPosition = anchor.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - configuratorHeaderOffset();
          smoothScrollTo(offsetPosition, SCROLL_DURATION_MS);
        }, 250);
      }

      updateTotal();
      updateFormInputs();
    });
  });

  function parsePrice(priceText) {
    // Удаляем все символы кроме цифр и точки/запятой
    const cleanPrice = priceText.replace(/[^\d.,]/g, '').replace(',', '.');
    return parseFloat(cleanPrice) || 0;
  }

  // Цену берём из data-price — целое число в центах, как его отдаёт Liquid
  // ({{ price }} уже в валюте текущего маркета). Парсить отформатированный
  // money-текст нельзя: разделитель тысяч (например CA$1,150.00) ломает разбор
  // (parseFloat('1.150.00') === 1.15). Fallback на текст, если атрибута нет.
  function readPrice(card) {
    if (!card) return 0;
    const cents = card.getAttribute('data-price');
    if (cents !== null && cents !== '' && !isNaN(cents)) {
      return parseInt(cents, 10) / 100;
    }
    const priceEl = card.querySelector('.configurator-card-price');
    return priceEl ? parsePrice(priceEl.textContent) : 0;
  }

  function formatPrice(price) {
    // Форматируем цену согласно валюте магазина (а не хардкоженного USD).
    // Shopify предоставляет активную валюту через window.Shopify.currency.active.
    const shopCurrency =
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    const locale = (document.documentElement.lang || navigator.language || 'en-US').replace('_', '-');
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: shopCurrency
      }).format(price);
    } catch (e) {
      // Fallback на en-US, если локаль некорректна
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: shopCurrency
      }).format(price);
    }
  }

  function setTotalText(value) {
    totalElements.forEach(el => { el.textContent = value; });
  }

  function resetTotalToMainProduct() {
    setTotalText(formatPrice(mainProductPrice));
  }

  // packageSelected → показываем sticky-сумму и кнопку (прячем подсказку);
  // canBuy → кнопки активны (есть хотя бы один товар к покупке).
  function setStickyState(packageSelected, canBuy) {
    if (stickyCta) {
      stickyCta.classList.toggle('hidden', !packageSelected);
      stickyCta.disabled = !canBuy;
    }
    if (stickySubtotal) stickySubtotal.classList.toggle('hidden', !packageSelected);
    if (stickyPrompt) stickyPrompt.classList.toggle('hidden', packageSelected);
    if (footerCta) footerCta.disabled = !canBuy;
  }

  function clearFormInputs() {
    if (!productForm) return;

    // Удаляем все динамически созданные input'ы (кроме основных)
    const dynamicInputs = productForm.querySelectorAll('input[name*="items["]');
    dynamicInputs.forEach(input => input.remove());

    // Сбрасываем индекс
    currentItemIndex = 1;
  }

  function appendHidden(name, value) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    productForm.appendChild(input);
  }

  function isWarrantyActive() {
    return Array.from(warrantyCards).some(card => card.classList.contains('active'));
  }

  function getWarrantyVariantId() {
    const activeCard = Array.from(warrantyCards).find(card => card.classList.contains('active'));
    return activeCard ? activeCard.getAttribute('data-warranty-variant-id') : null;
  }

  function updateFormInputs() {
    if (!productForm) return;

    // Сначала очищаем существующие динамические input'ы
    clearFormInputs();

    // Получаем все активные товары (видимые — скрытые дубли игнорируем)
    const activeProducts = document.querySelectorAll('.configurator-card-product.active:not(.is-duplicate-hidden)');

    const seenIds = new Set();
    let itemIndex = currentItemIndex;

    activeProducts.forEach((product) => {
      const productId = product.getAttribute('data-id');

      if (!productId || seenIds.has(productId)) return;
      seenIds.add(productId);

      appendHidden(`items[${itemIndex}][id]`, productId);
      appendHidden(`items[${itemIndex}][quantity]`, '1');
      itemIndex++;
    });

    // Warranty line — attach properties linking it to the main crossbow variant.
    const warrantyVariantId = getWarrantyVariantId();
    if (warrantyVariantId && !seenIds.has(warrantyVariantId)) {
      const mainVariantId = mainVariantIdInput ? mainVariantIdInput.value : '';
      appendHidden(`items[${itemIndex}][id]`, warrantyVariantId);
      appendHidden(`items[${itemIndex}][quantity]`, '1');
      if (mainVariantId) {
        appendHidden(`items[${itemIndex}][properties][_crossbow_variant_id]`, mainVariantId);
      }
      appendHidden(`items[${itemIndex}][properties][_type]`, 'warranty');
      itemIndex++;
    }
  }

  function updateTotal() {
    let total = 0;

    // Проверяем какой пакет активен
    const activePackage = document.querySelector('.configurator-card-package.active');

    if (!activePackage) {
      // Если нет активного пакета — блокируем sticky CTA и прячем футер
      setStickyState(false, false);
      if (configuratorFooter) configuratorFooter.classList.add('hidden');
      if (warrantyRow) warrantyRow.classList.add('hidden');
      return;
    }

    // Цена арбалета — только если он включён (его можно убрать).
    if (crossbowIncluded()) total += mainProductPrice;

    // Добавляем цены выбранных аксессуаров (уникальные, без дублей).
    // Работает и для Base Package + Add accessories: в Base нет
    // автовыбранных товаров, поэтому цикл просто даст 0, если
    // ничего не отмечено, и увеличит сумму на каждый чекбокс.
    const activeProducts = document.querySelectorAll('.configurator-card-product.active:not(.is-duplicate-hidden)');
    const seenIds = new Set();

    activeProducts.forEach(product => {
      const productId = product.getAttribute('data-id');
      if (productId && seenIds.has(productId)) return;
      if (productId) seenIds.add(productId);

      total += readPrice(product);
    });

    // Warranty adds to subtotal when toggled on.
    const activeWarranty = Array.from(warrantyCards).find(card => card.classList.contains('active'));
    if (activeWarranty) {
      const cents = parseInt(activeWarranty.getAttribute('data-warranty-price'), 10);
      if (!isNaN(cents)) total += cents / 100;
    }

    setTotalText(formatPrice(total));

    // Покупка возможна, только если выбран хотя бы один товар:
    // арбалет включён ИЛИ отмечен хотя бы один аксессуар.
    const hasItems = crossbowIncluded() || seenIds.size > 0;

    // …и при этом включённый арбалет должен быть в наличии. Если он распродан
    // и всё ещё в пакете — блокируем кнопку и показываем подсказку снять его.
    const crossbowBlocking = crossbowIncluded() && !crossbowAvailable();
    if (soldoutNote) soldoutNote.classList.toggle('hidden', !crossbowBlocking);

    setStickyState(true, hasItems && !crossbowBlocking);
  }

  // Обработка деталей карточек товаров
  function initCardDetails() {
    const detailsToggles = document.querySelectorAll('.configurator-card-details-toggle');
    const detailsCloses = document.querySelectorAll('.configurator-card-details-close');

    // Функция для закрытия всех открытых деталей
    function closeAllDetails() {
      const activeDetails = document.querySelectorAll('.configurator-card-details.active');
      activeDetails.forEach(details => {
        details.classList.remove('active');
      });
      document.body.style.overflow = ''; // Восстанавливаем скролл страницы
    }

    // Обработчики для открытия деталей
    detailsToggles.forEach(toggle => {
      toggle.addEventListener('click', function (e) {
        e.stopPropagation(); // Предотвращаем всплытие события к карточке

        const card = this.closest('.configurator-card-product, .configurator-card');
        const details = card.querySelector('.configurator-card-details');

        if (details) {
          // Сначала закрываем все открытые детали
          closeAllDetails();

          // Затем открываем нужные
          details.classList.add('active');
          document.body.style.overflow = 'hidden'; // Блокируем скролл страницы
        }
      });
    });

    // Обработчики для закрытия деталей
    detailsCloses.forEach(close => {
      close.addEventListener('click', function (e) {
        e.stopPropagation(); // Предотвращаем всплытие события

        const details = this.closest('.configurator-card-details');
        if (details) {
          details.classList.remove('active');
          document.body.style.overflow = ''; // Восстанавливаем скролл страницы
        }
      });
    });

    // Закрытие по клику на overlay (фон)
    const detailsElements = document.querySelectorAll('.configurator-card-details');
    detailsElements.forEach(details => {
      details.addEventListener('click', function (e) {
        // Закрываем только если клик был по самому overlay, а не по содержимому
        if (e.target === this) {
          this.classList.remove('active');
          document.body.style.overflow = '';
        }
      });
    });

    // Закрытие по ESC
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        const activeDetails = document.querySelector('.configurator-card-details.active');
        if (activeDetails) {
          activeDetails.classList.remove('active');
          document.body.style.overflow = '';
        }
      }
    });
  }

  // Инициализируем детали карточек
  initCardDetails();

  // --- Сабмит конфигуратора: добавляем каждый товар отдельным запросом ---
  // Раньше форма делала один POST /cart/add с арбалетом в поле `id` и
  // аксессуарами в `items[]`. На такой сабмит Shopify слал ОДНО событие
  // product_added_to_cart — только по арбалету (поле id), аксессуары были
  // невидимы для Meta/Google. Теперь добавляем КАЖДЫЙ товар отдельным
  // /cart/add.js: каждое одиночное добавление = штатный product_added_to_cart,
  // поэтому нативные коннекторы шлют корректный per-item AddToCart (правильный
  // ID каталога, цена, дедуп client/server). Распроданный арбалет просто
  // пропускается (его одиночное добавление вернёт 422) — без фантомного события.
  function buildConfiguratorLineItems() {
    const items = [];
    const seen = new Set();

    // 1) Арбалет — первым, если он включён в пакет.
    if (crossbowIncluded() && mainVariantIdInput && mainVariantIdInput.value) {
      items.push({ id: mainVariantIdInput.value, quantity: 1 });
      seen.add(mainVariantIdInput.value);
    }

    // 2) Аксессуары — активные карточки, без дублей.
    document
      .querySelectorAll('.configurator-card-product.active:not(.is-duplicate-hidden)')
      .forEach(card => {
        const id = card.getAttribute('data-id');
        if (!id || seen.has(id)) return;
        seen.add(id);
        items.push({ id: id, quantity: 1 });
      });

    // 3) Гарантия — последней, с properties (привязка к варианту арбалета).
    const warrantyId = getWarrantyVariantId();
    if (isWarrantyActive() && warrantyId && !seen.has(warrantyId)) {
      seen.add(warrantyId);
      const properties = { _type: 'warranty' };
      const mainId = mainVariantIdInput ? mainVariantIdInput.value : '';
      if (mainId) properties._crossbow_variant_id = mainId;
      items.push({ id: warrantyId, quantity: 1, properties: properties });
    }

    return items;
  }

  async function addConfiguratorItems(items) {
    const addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
    const added = [];
    const failed = [];
    for (const item of items) {
      try {
        const res = await fetch(addUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(item)
        });
        (res.ok ? added : failed).push(item);
      } catch (e) {
        failed.push(item);
      }
    }
    return { added, failed };
  }

  let configuratorSubmitting = false;

  function setConfiguratorCtaLoading(loading) {
    // Показываем крутящийся спиннер внутри синей кнопки (как в стандартной
    // product-form). НЕ ставим disabled/aria-disabled — они дают opacity: 0.5
    // (base.css), из-за чего кнопка выглядела полупрозрачной и «зависшей».
    // Кнопка остаётся полностью синей, текст скрывается (.button.loading →
    // color: transparent), повторный сабмит блокирует флаг configuratorSubmitting.
    [footerCta, stickyCta].forEach(btn => {
      if (!btn) return;
      btn.classList.toggle('loading', loading);
      btn.setAttribute('aria-busy', loading ? 'true' : 'false');
      var spinner = btn.querySelector('.loading__spinner');
      if (spinner) spinner.classList.toggle('hidden', !loading);
    });
  }

  function initConfiguratorSubmit() {
    if (!productForm) return;
    productForm.addEventListener('submit', async function (e) {
      e.preventDefault();
      if (configuratorSubmitting) return;

      const items = buildConfiguratorLineItems();
      if (!items.length) return;

      configuratorSubmitting = true;
      setConfiguratorCtaLoading(true);

      const { added } = await addConfiguratorItems(items);

      if (added.length) {
        // Успех (хотя бы частичный) — переходим в корзину, как и раньше.
        window.location = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
        return;
      }

      // Ничего не добавилось (всё распродано) — снимаем загрузку, показываем подсказку.
      configuratorSubmitting = false;
      setConfiguratorCtaLoading(false);
      if (soldoutNote) soldoutNote.classList.remove('hidden');
    });
  }

  initConfiguratorSubmit();

  // Функция изменения цвета иконки Shop Pay
  function styleShopPayIcon() {
    const paymentTerms = document.querySelector('.configurator shopify-payment-terms');
    if (!paymentTerms) return;

    function injectStyle() {
      if (paymentTerms.shadowRoot) {
        const style = document.createElement('style');
        style.textContent = `
          svg {
            fill: #284DD7 !important;
            color: #284DD7 !important;
          }
          svg path {
            fill: #284DD7 !important;
          }
        `;
        paymentTerms.shadowRoot.appendChild(style);
      } else {
        setTimeout(injectStyle, 500);
      }
    }

    // Пробуем сразу и с задержкой, так как элемент может обновляться
    injectStyle();
    setTimeout(injectStyle, 2000);
  }

  styleShopPayIcon();
});
